// tracking/data-view
import { getData } from 'src/services/RestApi';
import { formatDate, currentSeconds } from 'src/utils/date-locale';
import { formatQuantity, calculateTotalFuel, formatCode, formatPhone } from 'src/utils/formatters';
import { convertResponseItem } from './helper';

export const getList = async () => {
  const { result, error } = await getData('api/tracking/list');
  if (error) return [];
  
  return result;
};

export const getItemById = async (payload) => {
  console.log('Payload ===', payload);

  const trackingId = Number(payload?.id) || 0;
  if (trackingId === 0) return {};

  const { result, error } = await getData('api/tracking/detail', { trackingId });
  if(error) return payload;

  console.log('Payload ===', payload);

  return payload;
};


export const selectTrackingStudent = async (payload) => {
  const studentId = Number(payload?.id) || 0;
  if (studentId === 0) return {};
  
  const endPoint = 'api/tracking/student/list';
  let { result, error } = await getData(endPoint, { studentId });

  if(error) return payload;

  const arrayTemp = [];
  result.forEach(element => {
    const json = convertResponseItem(element);
    arrayTemp.push(json);
    // console.log('===', json);
    // arrayTemp.push({
    //   optionId: element.trackingId,
    //   optionName: element.trackingName,
    //   optionStatus: element.statusName,
    //   remindSecond: element.remindAt,
    //   step: element.trackingStep,
    //   id: element.id,
    //   createdAt: formatDate(element.orderTime, 'dd/MM/yyyy'),
    //   remindAt: formatDate(element.remindAt, 'dd/MM/yyyy')
    // });
  });
  payload.tracking = arrayTemp;

  return payload;
};
